const dataObject = {
  consignee_name: "",
  consignee: "",
  rate_info: [],
};

function validate(values) {
  let errors = {};
  return errors;
}

const quotationTableHeader = [
  { label: "S. No.", className: "text-center table-header" },
  { label: "Station From", className: "text-center table-header" },
  { label: "Station To", className: "text-center table-header" },
  { label: "Item Name", className: "text-center table-header" },
  { label: "Unit", className: "text-center table-header" },
  { label: "Rate", className: "text-center table-header" },
];

const quotationTableItems = [
  {
    type: "text",
    name: "station_from_name",
    label: "Station From",
    className: "form-control-large-col",
  },
  {
    type: "text",
    name: "station_to_name",
    label: "Station To",
    className: "form-control-large-col",
  },
  {
    type: "text",
    name: "item_name",
    label: "Item Name",
    className: "form-control-large-col",
  },
  {
    type: "text",
    name: "unit",
    label: "Unit",
    className: "form-control-small-col",
  },
  {
    type: "text",
    name: "rate",
    label: "Rate",
    className: "form-control-large-col",
  },
];

const popupInfo = {
  error_header: "Error In Quotation Module ",
  success_header: "Quotation Successful ",
  success_title: "Quotation is successfully created",
  field_label_success: "",
  field_name_success: "",
  error_title: "Error in Quotation module with the following info:-",
  field_label_error: "Error:",
};

export {
  quotationTableHeader,
  quotationTableItems,
  dataObject,
  validate,
  popupInfo,
};
